@if (showPill()) {
  <!-- back + title on the left, language pill on the right (matches consultation-chat-header) -->
  <div class="tw-z-[100] tw-flex tw-justify-between tw-items-center tw-h-14 tw-pl-2 tw-pr-4 tw-bg-gray-800 tw-font-lexend"
       [class.tw-sticky]="sticky()"
       [class.tw-top-0]="sticky()">
    <div class="tw-flex tw-items-center">
      <div class="tw-flex tw-justify-center tw-items-center tw-p-2">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
                 [iconName]="'arrow_back'"
                 (click)="back.emit()"></cs-icon>
      </div>
      <span class="tw-font-lexend tw-font-bold tw-text-300 tw-text-white">{{ title() }}</span>
    </div>
    <chat-language-pill [consultationSession]="consultationSession()"
                        [botReplyInProgress]="botReplyInProgress()"
                        [translateChatMessages]="translateChatMessages()"></chat-language-pill>
  </div>
} @else {
  <!-- centered title; back button anchored to the header (relative), not the viewport -->
  <div class="tw-z-[100] tw-relative tw-flex tw-justify-center tw-items-center tw-h-14 tw-px-6 tw-bg-gray-800 tw-font-lexend"
       [class.tw-sticky]="sticky()"
       [class.tw-top-0]="sticky()">
    <cs-icon class="tw-absolute tw-left-6 tw-h-6 tw-w-6 tw-text-gray-50"
             [iconName]="'arrow_back'"
             (click)="back.emit()"></cs-icon>
    <span class="tw-font-lexend tw-font-bold tw-text-300 tw-text-white">{{ title() }}</span>
  </div>
}
